<template>
  <!-- categoryList决定筛选项是否显示 -->
  <!-- v-if="categoryList && categoryList.list && categoryList.list.length" -->
  <div class="plp-nav-side-mobile">
    <div
      v-if="
        categoryList.list && categoryList.list.length && $route.name !== 'plpSearch' && showTypeSide
      "
      style="height: 32px; white-space: nowrap; overflow-x: auto; margin-bottom: 20px"
    >
      <!-- TODO：装备应该是动态取的 -->
      <!-- active: !packedCategoryList().some(ele => selectedCodeList.includes(ele.code)) -->
      <!-- @click="onChange([], { type: 'CHECKBOX', code: 'CATEGORY', isAll: true })" -->
      <!-- active: !categoryList.list[0].list.some(ele => selectedCodeList.includes(ele.code)) -->
      <!-- @click="onChange(categoryList.list[0], { type: 'CHECKBOX', code: 'CATEGORY', isAll: true })" -->
      <div
        class="plp-nav-side-mobile__sub-item"
        :class="{
          active: !packedCategoryList().some(ele => selectedCodeList.includes(ele.code))
        }"
        @click="onChange([], { type: 'CHECKBOX', code: 'CATEGORY', isAll: true })"
      >
        全部
      </div>
      <!-- v-for="(cell, index) in packedCategoryList()" -->
      <!-- v-for="(cell, index) in categoryList.list[0].list" -->
      <div
        v-for="(cell, index) in packedCategoryList()"
        :key="index"
        class="plp-nav-side-mobile__sub-item"
        :class="{
          active: !unidirectionSelectedDataStatus && selectedCodeList.includes(cell.code)
        }"
        @click="onChange(cell, { ...categoryList, isAll: false })"
      >
        {{ cell.name }}
      </div>
    </div>
    <div class="plp-nav-side-mobile__sort">
      <span class="plp-nav-side-mobile__sort-span" @click="resetVisible(1), (visible1 = !visible1)">
        <span class="show-text-span" :class="{ 'radio-search': radioSearch == 1 }">
          {{ sort == 'soldQty' ? '销量' : '综合' }}
        </span>
        <svg
          :class="{ rotate: visible1 }"
          class="arrow-down-transition middle"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="16-1px-down-s">
            <path
              id="Vector 2 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45119 12.1583 5.45119 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45119 6.15829 3.45119 5.84171 3.64645 5.64645Z"
              fill="#14141E"
            />
          </g>
        </svg>
      </span>
      <span
        class="plp-nav-side-mobile__sort-span"
        style="margin-left: 16px"
        :class="{ 'ml-auto': mlAuto }"
        @click="resetVisible(2), rotatePrice()"
      >
        <span class="show-text-span" :class="{ 'radio-search': radioSearch == 2 }">价格</span>
        <svg
          v-if="priceStatus == 0"
          class="middle"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="16-1px-&#230;&#142;&#146;&#229;&#186;&#143;">
            <path
              id="Vector 2 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.3536 6.85209C12.1583 7.04735 11.8417 7.04735 11.6464 6.85209L8 3.20564L4.35355 6.85209C4.15829 7.04735 3.84171 7.04735 3.64645 6.85209C3.45118 6.65683 3.45118 6.34024 3.64645 6.14498L7.64645 2.14498C7.74021 2.05121 7.86739 1.99854 8 1.99854C8.13261 1.99854 8.25979 2.05121 8.35355 2.14498L12.3536 6.14498C12.5488 6.34024 12.5488 6.65683 12.3536 6.85209Z"
              fill="#B4B4BF"
            />
            <path
              id="Vector 3 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.64645 9.14498C3.84171 8.94972 4.15829 8.94972 4.35355 9.14498L8 12.7914L11.6464 9.14498C11.8417 8.94972 12.1583 8.94972 12.3536 9.14498C12.5488 9.34024 12.5488 9.65683 12.3536 9.85209L8.35355 13.8521C8.15829 14.0474 7.84171 14.0474 7.64645 13.8521L3.64645 9.85209C3.45118 9.65683 3.45118 9.34024 3.64645 9.14498Z"
              fill="#B4B4BF"
            />
          </g>
        </svg>
        <svg
          v-if="priceStatus == 1 || priceStatus == 2"
          :class="{ rotate: priceStatus === 1 }"
          class="middle"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="16-1px-&#230;&#142;&#146;&#229;&#186;&#143;-2">
            <path
              id="Vector 2 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.3536 6.85209C12.1583 7.04735 11.8417 7.04735 11.6464 6.85209L8 3.20564L4.35355 6.85209C4.15829 7.04735 3.84171 7.04735 3.64645 6.85209C3.45118 6.65683 3.45118 6.34024 3.64645 6.14498L7.64645 2.14498C7.74021 2.05121 7.86739 1.99854 8 1.99854C8.13261 1.99854 8.25979 2.05121 8.35355 2.14498L12.3536 6.14498C12.5488 6.34024 12.5488 6.65683 12.3536 6.85209Z"
              fill="#B4B4BF"
            />
            <path
              id="Vector 3 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.64645 9.14498C3.84171 8.94972 4.15829 8.94972 4.35355 9.14498L8 12.7914L11.6464 9.14498C11.8417 8.94972 12.1583 8.94972 12.3536 9.14498C12.5488 9.34024 12.5488 9.65683 12.3536 9.85209L8.35355 13.8521C8.15829 14.0474 7.84171 14.0474 7.64645 13.8521L3.64645 9.85209C3.45118 9.65683 3.45118 9.34024 3.64645 9.14498Z"
              fill="#14141E"
            />
          </g>
        </svg>
      </span>
      <span
        v-if="sexList.list && sexList.list.length > 1"
        class="plp-nav-side-mobile__sort-span sex-span"
        style="margin-left: 16px"
        :class="{ 'ml-auto': mlAuto }"
        @click="resetVisible(3), (visible3 = !visible3)"
      >
        <span
          class="show-text-span"
          :class="{ 'radio-search': selSexList && selSexList.length > 0 }"
        >
          {{
            selSexList && selSexList.length > 0
              ? selSexList
                  .map(ele => {
                    return ele.name;
                  })
                  .join('/')
              : '性别'
          }}
        </span>
        <svg
          :class="{ rotate: visible3 }"
          class="arrow-down-transition middle"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="16-1px-down-s">
            <path
              id="Vector 2 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45119 12.1583 5.45119 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45119 6.15829 3.45119 5.84171 3.64645 5.64645Z"
              fill="#14141E"
            />
          </g>
        </svg>
      </span>
      <span
        class="plp-nav-side-mobile__sort-span size-span"
        style="margin-left: 16px"
        :class="{ 'ml-auto': mlAuto }"
        @click="resetVisible(4), (visible2 = !visible2)"
      >
        <span
          class="show-text-span"
          :class="{ 'radio-search': selSizeList && selSizeList.length > 0 }"
        >
          {{
            selSizeList && selSizeList.length > 0
              ? selSizeList
                  .map(ele => {
                    return ele.name;
                  })
                  .join('/')
              : '尺码'
          }}
        </span>
        <svg
          :class="{ rotate: visible2 }"
          class="arrow-down-transition middle"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="16-1px-down-s">
            <path
              id="Vector 2 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45119 12.1583 5.45119 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45119 6.15829 3.45119 5.84171 3.64645 5.64645Z"
              fill="#14141E"
            />
          </g>
        </svg>
      </span>
      <span
        class="plp-nav-side-mobile__sort-span"
        style="margin-left: 16px; margin-right: 20px"
        :class="{ 'ml-auto': mlAuto }"
        @click="resetVisible(5), selectNewProduct()"
      >
        <span class="show-text-span" :class="{ 'radio-search': radioSearch == 3 }">新品</span>
      </span>
      <span
        id="product-filter-mobile-filter-button-id"
        class="plp-nav-side-mobile__sort-span"
        style="margin-left: auto"
        :class="{ 'ml-auto': !mlAuto }"
        @click="resetVisible(6), clickFilterButton()"
      >
        <span class="show-text-span">筛选</span>
        <svg
          class="middle"
          width="14"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Group 16">
            <path
              id="Union"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.5 8.99951C13.7761 8.99951 14 9.22337 14 9.49951C14 9.77565 13.7761 9.99951 13.5 9.99951H11.1035C10.8815 10.8621 10.0984 11.4995 9.1665 11.4995C8.23458 11.4995 7.45154 10.8621 7.22951 9.99951H0.5C0.223857 9.99951 0 9.77565 0 9.49951C0 9.22337 0.223858 8.99951 0.5 8.99951H7.22951C7.45153 8.1369 8.23458 7.49951 9.1665 7.49951C10.0984 7.49951 10.8815 8.1369 11.1035 8.99951H13.5ZM8.1665 9.49951C8.1665 10.0518 8.61422 10.4995 9.1665 10.4995C9.71879 10.4995 10.1665 10.0518 10.1665 9.49951C10.1665 8.94723 9.71879 8.49951 9.1665 8.49951C8.61422 8.49951 8.1665 8.94723 8.1665 9.49951Z"
              fill="#14141E"
            />
            <path
              id="Union_2"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.5 2.99951C0.223858 2.99951 0 2.77565 0 2.49951C0 2.22337 0.223858 1.99951 0.5 1.99951H2.8965C3.11853 1.1369 3.90158 0.499512 4.8335 0.499512C5.76542 0.499512 6.54846 1.1369 6.77049 1.99951H13.5C13.7761 1.99951 14 2.22337 14 2.49951C14 2.77565 13.7761 2.99951 13.5 2.99951H6.77049C6.54847 3.86212 5.76542 4.49951 4.8335 4.49951C3.90158 4.49951 3.11853 3.86213 2.8965 2.99951H0.5ZM5.8335 2.49951C5.8335 1.94723 5.38578 1.49951 4.8335 1.49951C4.28121 1.49951 3.8335 1.94723 3.8335 2.49951C3.8335 3.0518 4.28121 3.49951 4.8335 3.49951C5.38578 3.49951 5.8335 3.0518 5.8335 2.49951Z"
              fill="#14141E"
            />
          </g>
        </svg>
      </span>
    </div>
    <PlpDrawer
      id="plp-drawer-mobile"
      ref="plp-drawer"
      :total-count="totalCount"
      :on-filter="onFilter"
      :filter-data="filterData"
      :reset-filter-data="resetFilterData"
      :params="params"
      :show-type-side="showTypeSide"
      :unidirection-selected-data-status="unidirectionSelectedDataStatus"
      @onSelected="onSelected"
      @mergeOption="mergeOption"
      @resetParentFilterOption="resetParentFilterOption"
    ></PlpDrawer>
    <div class="ttb-drawer">
      <GtDrawer
        :visible.sync="visible1"
        size="100%"
        direction="ttb"
        :with-header="false"
        :append-to-body="false"
        :modal="false"
        class="plp-sort_drawer"
      >
        <div ref="sortRef" class="popover-box2">
          <div
            class="dropdown-item"
            :class="{ 'select-1': sort == 'sort' }"
            @click="onSortChangeI('sort')"
          >
            <span style="flex: 1">综合</span>
            <svg
              v-if="sort == 'sort'"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="float: right"
            >
              <g id="16-1px-SUCEESS">
                <g id="e">
                  <path
                    id="Vector"
                    d="M14.6668 3.33301L5.78016 12.6663L1.3335 7.99967"
                    stroke="#14141E"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <path
                  id="Vector (Stroke)"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.0116 2.9709C15.2116 3.16131 15.2194 3.4778 15.0289 3.67779L6.14228 13.0111C6.04792 13.1102 5.91709 13.1663 5.78026 13.1663C5.64343 13.1664 5.51257 13.1103 5.41818 13.0113L0.971514 8.34459C0.781021 8.14468 0.788661 7.82819 0.988579 7.63769C1.1885 7.4472 1.50499 7.45484 1.69548 7.65476L5.78003 11.9414L14.3047 2.98823C14.4951 2.78824 14.8116 2.78048 15.0116 2.9709Z"
                  fill="#14141E"
                />
              </g>
            </svg>
          </div>
          <div
            class="dropdown-item"
            style="height: 46px; line-height: 46px"
            :class="{ 'select-1': sort == 'soldQty' }"
            @click="onSortChangeI('soldQty')"
          >
            <span style="flex: 1">销量</span>
            <svg
              v-if="sort == 'soldQty'"
              width="16"
              height="16"
              margin-bottoppx
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="float: right"
            >
              <g id="16-1px-SUCEESS">
                <g id="e">
                  <path
                    id="Vector"
                    d="M14.6668 3.33301L5.78016 12.6663L1.3335 7.99967"
                    stroke="#14141E"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <path
                  id="Vector (Stroke)"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.0116 2.9709C15.2116 3.16131 15.2194 3.4778 15.0289 3.67779L6.14228 13.0111C6.04792 13.1102 5.91709 13.1663 5.78026 13.1663C5.64343 13.1664 5.51257 13.1103 5.41818 13.0113L0.971514 8.34459C0.781021 8.14468 0.788661 7.82819 0.988579 7.63769C1.1885 7.4472 1.50499 7.45484 1.69548 7.65476L5.78003 11.9414L14.3047 2.98823C14.4951 2.78824 14.8116 2.78048 15.0116 2.9709Z"
                  fill="#14141E"
                />
              </g>
            </svg>
          </div>
        </div>
      </GtDrawer>
      <GtDrawer
        :visible.sync="visible3"
        size="100%"
        direction="ttb"
        title="性别"
        :append-to-body="false"
        :modal="false"
        class="plp-sort_drawer"
        :show-close="false"
      >
        <div ref="sexRef">
          <div class="popover-box">
            <PdtSizePicker
              v-model="bindValue2"
              :option="sexList.list || []"
              multiple
              label-key="name"
              value-key="code"
            />
          </div>
          <div class="popover-bottom">
            <GtButton
              type="text"
              class="popover-bottom__common popover-bottom__cancel"
              @click.capture="handleSelect2(false)"
            >
              重置
            </GtButton>
            <GtButton
              type="primary"
              class="popover-bottom__common popover-bottom__confirm"
              @click.capture="handleSelect2(true)"
            >
              确定
            </GtButton>
          </div>
        </div>
      </GtDrawer>
      <GtDrawer
        :visible.sync="visible2"
        size="100%"
        direction="ttb"
        title="尺码"
        :append-to-body="false"
        :modal="false"
        class="plp-sort_drawer"
        :show-close="false"
      >
        <div ref="sizeRef">
          <div class="popover-box">
            <PdtSizePicker
              v-model="bindValue"
              :option="sizeList.list || []"
              multiple
              label-key="name"
              value-key="code"
            />
          </div>
          <div class="popover-bottom">
            <GtButton
              size="medium"
              type="text"
              class="popover-bottom__common popover-bottom__cancel"
              @click.capture="handleSelect(false)"
            >
              重置
            </GtButton>
            <GtButton
              size="medium"
              type="primary"
              class="popover-bottom__common popover-bottom__confirm"
              @click.capture="handleSelect(true)"
            >
              确定
            </GtButton>
          </div>
        </div>
      </GtDrawer>
    </div>
    <!-- <div
      v-if="showCircle"
      id="product-filter-mobile-circle-id"
      class="product-filter-mobile-circle-class"
    ></div> -->
  </div>
</template>

<script>
import { GtCollapse, GtCollapseItem, GtButton, GtDrawer } from '@speedshop/template';

import { Dropdown, DropdownItem, DropdownMenu, Popover, Button } from 'element-ui';
import { CatalogProduct, CatalogWcmProduct } from '@/utils/product';
import PdtSizePicker from '@/components/PDP/SizePicker.vue';
import PlpDrawer from '@/components/PLP/drawer.vue';
import { scrollToTop } from '@/utils/dom';

export default {
  components: {
    GtCollapse,
    GtCollapseItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Popover,
    ElButton: Button,
    PdtSizePicker,
    PlpDrawer,
    GtButton,
    GtDrawer
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    filterData: {
      type: Array,
      default: () => []
    },

    onFilter: {},
    totalCount: {},
    resetFilterData: {},
    params: {},
    pageTitle: {
      type: String,
      default: () => {
        return '';
      }
    },
    showTypeSide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const item = (this.data || []).find(item => JSON.stringify(item).includes(this.$route.path));
    return {
      activeList: item ? [item.navigationCode] : [],
      selectedData: {},
      visible1: false,
      visible2: false,
      visible3: false,
      bindValue: [],
      bindValue2: [],
      sort: 'sort',
      // SortMapping: {
      //   sort: { name: '默认', index: 0 },
      //   'onboardTime-0': { name: '最新', index: 1 },
      //   soldQty: { name: '热卖', index: 2 },
      //   'price-0': { name: '价格从低到高', index: 3 },
      //   'price-1': { name: '价格从高到低', index: 4 }
      // },
      SortMapping: {
        sort: { name: '默认', index: 0 },
        firstOnboardTime: { name: '最新', index: 1 },
        soldQty: { name: '热卖', index: 2 },
        'price-0': { name: '价格从低到高', index: 3 },
        'price-1': { name: '价格从高到低', index: 4 }
      },
      priceStatus: 0,
      radioSearch: 1,
      showCircle: false,
      unidirectionSelectedDataStatus: false,
      mlAuto: false,
      sortRef: null,
      sizeRef: null,
      sexRef: null
    };
  },
  computed: {
    mainData() {
      return this.data.slice(0, this.data.length - 1);
    },
    recommendData() {
      const data = this.data[this.data.length - 1];
      return data && data.children ? data.children : [];
    },

    selectedCodeList() {
      return this.selectedList.map(i => i.code);
    },
    categoryList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      function findSecondLastChildrenWithChildren(tree) {
        const secondLastChildrenWithChildren = [];

        function traverse(node, depth) {
          if (!node.list || node.list.length === 0) {
            return;
          }
          const firstChild = node.list[0];

          if (firstChild.list && firstChild.list.length) {
            for (const child of node.list) {
              traverse(child, depth - 1);
            }
          } else {
            secondLastChildrenWithChildren.push(node);
          }

          // if (depth === 1) {
          //   secondLastChildrenWithChildren.push(node);
          //   return;
          // }

          // for (const child of node.list) {
          //   traverse(child, depth - 1);
          // }
        }

        for (const root of tree) {
          traverse(root, 2);
        }

        return secondLastChildrenWithChildren;
      }

      const { list = [], ...others } = data;

      const newList = list.map(item => {
        const children = item.children.map(i => {
          return {
            ...i,
            list: (i.list || i.children || []).map(e => {
              return {
                ...e,
                list: (e.list || e.children || []).map(c => {
                  return {
                    ...c,
                    list: c.list || c.children,
                    name: c.name || c.categoryName
                  };
                }),
                name: e.name || e.categoryName
              };
            }),
            name: i.name || i.categoryName
          };
        });
        return {
          ...item,
          list: children,
          name: item?.name || item.categoryName
        };
      });
      const { categoryCode, categoryCodeList = [] } = this.params || {};
      const filterCategory = [categoryCode, ...categoryCodeList].filter(i => i);
      const secondLastChildrenWithChildren = findSecondLastChildrenWithChildren(newList);
      // 过滤categoryCode
      const filterNoMatchData = secondLastChildrenWithChildren;
      // const filterNoMatchData = !filterCategory.length
      //   ? secondLastChildrenWithChildren
      //   : secondLastChildrenWithChildren.filter(i => {
      //   const matchChildren = i.list.some(c => {
      //     const pathCodeList = c.categoryPath?.split('>') || [];
      //     return filterCategory.some(e => {
      //       return pathCodeList.includes(e);
      //     });
      //   });
      //   return matchChildren;
      // });
      // 去重
      const myMap = new Map();
      filterNoMatchData.forEach(item => {
        const { name, list } = item;
        if (myMap.has(name)) {
          const data = myMap.get(name);
          list.forEach(i => {
            data.listMap.set(i.name, i);
          });
          myMap.set(name, { ...data, list: newList });
        } else {
          const listMap = new Map();
          list.forEach(i => {
            listMap.set(i.name, i);
          });
          myMap.set(name, { ...item, listMap });
        }
      });
      const newListMap = [...myMap.values()];
      const resultList = newListMap.map(i => {
        return {
          ...i,
          list: [...i.listMap.values()].map(item => {
            return {
              ...item,
              originalCode: item.categoryCode,
              categoryCode: item.name,
              code: item.name,
              attrCate: 'CATEGORY'
            };
          })
        };
      });
      return {
        ...others,
        list: resultList
      };
    },

    selectedList() {
      let list = [];
      for (const key in this.selectedData) {
        if (key === 'PRICE' && this.selectedData[key].length) {
          const price = this.selectedData[key][0];
          list = [...list, [{ name: price.join('-'), parentCode: 'PRICE' }]];
        } else {
          list = [...list, this.selectedData[key]];
        }
      }
      const data = list;
      const result = data.reduce((result, item) => {
        return [...result, ...item];
      }, []);
      return result;
    },

    sizeList() {
      const list = this.filterData.find(i => i.code === 'SIZE') || {};

      return list;
    },
    sortList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'SORT')) || {};
      let { list } = data;
      if (list && list.length) {
        list = [
          { code: 'sort', value: { name: 'sort', sort: '0' }, parentCode: 'Sort' },
          { code: 'soldQty', value: { name: 'soldQty', sort: '1' }, parentCode: 'Sort' },
          {
            code: 'firstOnboardTime',
            value: { name: 'firstOnboardTime', sort: '1' },
            parentCode: 'Sort'
          },
          ...list
        ]
          .filter(i => !['onboardTime-0', 'onboardTime-1'].includes(i.code))
          .map(item => {
            return {
              ...item,
              name: this.SortMapping[item.code].name
            };
          });
        list.sort((a, b) => {
          return this.SortMapping[a.code].index > this.SortMapping[b.code].index ? 1 : -1;
        });
        return { ...data, list };
      } else {
        return [];
      }
    },
    // sortList() {
    //   const data = (this.filterData && this.filterData.find(i => i.code === 'SORT')) || {};
    //   let { list } = data;
    //   if (list && list.length) {
    //     list = [
    //       { code: 'sort', value: { name: 'sort', sort: '0' } },
    //       { code: 'soldQty', value: { name: 'soldQty', sort: '1' } },
    //       ...list
    //     ]
    //       .filter(i => i.code !== 'onboardTime-1')
    //       .map(item => {
    //         return {
    //           ...item,
    //           name: this.SortMapping[item.code].name
    //         };
    //       });
    //     list.sort((a, b) => {
    //       return this.SortMapping[a.code].index > this.SortMapping[b.code].index ? 1 : -1;
    //     });
    //     return { ...data, list };
    //   } else {
    //     return [];
    //   }
    // },
    sexList() {
      const list = this.filterData.find(i => i.code === 'PDP_SEX') || {};

      return list;
    },
    tagList() {
      // return (this.filterData && this.filterData.find(i => i.code === 'TAG')) || {};
      // 写死tag
      return {
        attrCate: null,
        code: 'TAG',
        list: [
          {
            attrCate: null,
            attrType: undefined,
            checked: false,
            code: '新品',
            displayName: '新品推荐',
            name: '新品推荐',
            parentCode: 'Tag',
            parentName: 'Tag',
            status: '1',
            tagCode: '新品',
            tagName: '新品推荐'
          },
          {
            attrCate: null,
            attrType: undefined,
            checked: false,
            code: '热卖',
            displayName: '热卖商品',
            name: '热卖商品',
            parentCode: 'Tag',
            parentName: 'Tag',
            status: '1',
            tagCode: '热卖',
            tagName: '热卖商品'
          }
        ],
        name: 'Tag',
        type: 'CHECKBOX'
      };
    },
    selSexList() {
      return this.selectedData.PDP_SEX ? this.selectedData.PDP_SEX : [];
    },
    selSizeList() {
      return this.selectedData.SIZE ? this.selectedData.SIZE : [];
    },
    filterSideIsSticky() {
      return this.$store.state.filterSideIsSticky;
    }
  },
  watch: {
    sortRef(newValue) {
      if (newValue) {
        this.setupClickEvent(newValue);
      }
    },
    sizeRef(newValue) {
      if (newValue) {
        this.setupClickEvent(newValue);
      }
    },
    sexRef(newValue) {
      if (newValue) {
        this.setupClickEvent(newValue);
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.sortRef = this.$refs.sortRef;
      this.sizeRef = this.$refs.sizeRef;
      this.sexRef = this.$refs.sexRef;
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.setDrawerWrapperStyle();
      this.observeElementChanges();
      // this.computedSideTop();
      this.observeDOM();
      this.sortRef = this.$refs.sortRef;
      this.sizeRef = this.$refs.sizeRef;
      this.sexRef = this.$refs.sexRef;
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWidths);
    this.disconnectMutationObserver();
  },
  methods: {
    observeDOM() {
      // 创建一个观察者实例并传入回调函数
      const observer = new MutationObserver(mutation => {
        this.computedSideTop();
      });

      // 配置观察选项:
      const config = { attributes: true, childList: true, subtree: true };

      // 选择要观察变动的节点
      const targetNode = document.querySelector('#nuxt-app'); // 可以根据需要更改为更具体的父节点

      // 调用 observe 方法开始观察目标节点，以及观察变化类型
      observer.observe(targetNode, config);
    },
    computedSideTop() {
      // 尝试查询元素
      const element = !!document.querySelector('.gt-layout-without-ad');
      // 检查元素是否存在 设置另一个元素的top样式
      const targetElement = document.querySelector(
        '.page-layout_mobile .sp-plp-page > div > div:first-child'
      );
      if (targetElement) {
        targetElement.style.top = element ? '54px' : '95px';
      }
    },
    observeElementChanges() {
      // 选择要观察变化的元素
      const plpNavSideMobileSexSpan = document.querySelector('.sex-span');
      const plpNavSideMobileSizeSpan = document.querySelector('.size-span');

      // 创建 MutationObserver 实例
      this.mutationObserver = new MutationObserver(mutations => {
        this.checkWidths();
      });

      // 配置观察选项
      const config = {
        attributes: true,
        childList: true,
        subtree: true
      };

      // 开始观察目标元素

      console.log('observe1', plpNavSideMobileSexSpan);
      console.log('observe2', plpNavSideMobileSizeSpan);
      if (plpNavSideMobileSexSpan) {
        this.mutationObserver.observe(plpNavSideMobileSexSpan, config);
      }
      if (plpNavSideMobileSizeSpan) {
        this.mutationObserver.observe(plpNavSideMobileSizeSpan, config);
      }
    },
    disconnectMutationObserver() {
      if (this.mutationObserver) {
        // 停止观察目标元素
        this.mutationObserver.disconnect();
      }
    },
    // 筛选展示条件数量大或者屏幕小，自动分布，少量筛选条件，就按照设计图的靠左分布
    checkWidths() {
      this.$nextTick(() => {
        // 获取元素引用
        // const plpNavSideMobile = document.querySelector('.plp-nav-side-mobile');
        const plpNavSideMobileSort = document.querySelector('.plp-nav-side-mobile__sort');
        const plpNavSideMobileSexSpan = document.querySelector('.sex-span');
        const plpNavSideMobileSizeSpan = document.querySelector('.size-span');

        // 获取元素宽度
        // const plpNavSideMobileWidth = plpNavSideMobile.clientWidth;
        const plpNavSideMobileSortWidth = plpNavSideMobileSort.offsetWidth;
        const plpNavSideMobileSexSpanWidth = plpNavSideMobileSexSpan?.offsetWidth;
        const plpNavSideMobileSizeSpanWidth = plpNavSideMobileSizeSpan.offsetWidth;
        // 综合44px 价格44px-ml16 性别44px-ml16(不一定存在，宽度会变化) 尺码44px-ml16(宽度会变化) 新品24px-ml16 筛选42（至少ml20px）
        // 44+44+16+24+16+42+20=206
        const computeNum =
          plpNavSideMobileSortWidth -
          206 -
          (plpNavSideMobileSexSpanWidth ? plpNavSideMobileSexSpanWidth + 16 : 0) -
          (plpNavSideMobileSizeSpanWidth >= 44 ? plpNavSideMobileSizeSpanWidth + 16 : 0);
        if (computeNum > 0) {
          this.mlAuto = false;
        } else {
          this.mlAuto = true;
        }
      });
    },
    onChange(data, item) {
      // TODO: 全部xx点击筛选，值有问题，方法调用不成功
      const code = ['SLIDER'].includes(item.type)
        ? item.code
        : item.code === 'CATEGORY'
        ? item.code
        : data.parentCode;
      if (item.type === 'CHECKBOX') {
        if (item.code === 'CATEGORY') {
          if (item.isAll) {
            this.$set(this.selectedData, code, []);
          } else {
            this.$set(this.selectedData, code, [data]);
          }
          this.unidirectionSelectedDataStatus = false;
        } else {
          const checkedData = this.selectedData[code];
          if (checkedData) {
            const index = checkedData.findIndex(i => {
              return i.code === data.code;
            });
            index > -1 ? checkedData.splice(index, 1) : this.selectedData[code].push(data);
          } else {
            this.$set(this.selectedData, code, [data]);
          }
        }
        // this.$set(this.selectedData, code, [data]);
      } else if (item.type === 'SLIDER') {
        this.$set(this.selectedData, code, [data]);
      } else if (item.type === 'SELECT') {
        const checkedData = this.selectedData[code];
        if (checkedData) {
          const index = checkedData.findIndex(i => {
            return i.code === data.code;
          });
          index < 0 && this.selectedData[code].push(data);
        } else {
          this.$set(this.selectedData, code, [data]);
        }
      } else {
        this.$set(this.selectedData, code, [data]);
      }
      //  todo,选全部时，调用方法有问题
      if (this.isMobile) {
        //
        this.queryProductNum();
      } else {
        this.onFilter(this.selectedData[code], item);
        this.backToTop();
      }
      this.trackData(data.name);
      this.$emit('onSelected', this.selectedList);
    },

    async queryProductNum() {
      const categoryCodeList = this.selectedData.CATEGORY || [];
      const attrList = Object.keys(this.selectedData)
        .filter(i => {
          if (!this.selectedData[i] || !this.selectedData[i].length) return false;
          return this.selectedData[i][0].attrCate === 'SKUATTR';
        })
        .map(i => {
          const data = this.selectedData[i];
          const item = data[0];
          return {
            attrCode: i,
            attrType: item.attrType,
            attrValue: data.map(e => {
              return e.valueCode;
            })
          };
        });
      const spuAttrList = Object.keys(this.selectedData)
        .filter(i => {
          if (!this.selectedData[i] || !this.selectedData[i].length) return false;
          return this.selectedData[i][0].attrCate === 'SPUATTR';
        })
        .map(i => {
          const data = this.selectedData[i];
          const item = data[0];
          return {
            attrCode: i,
            attrType: item.attrType,
            attrValue: data.map(e => {
              return e.valueCode;
            })
          };
        });

      const sendData = {
        numberFilter: 'salePrice',
        categoryCodeList: categoryCodeList.map(i => i.code) || [],
        brandCodeList: [],
        fqList: [{ fq: 'ra', key: 'salePrice', value: this.priceRange.toString() }],
        attrList,
        spuAttrList
      };

      this.loading = true;
      // 初始化

      const plp = ['home', 'LandingPage', 'LandingPage-all'].includes(this.$route.name)
        ? CatalogWcmProduct()
        : CatalogProduct();
      plp.init({
        categoryExtCode: this.$route.params.category,
        hasFilter: false,
        conditionKeyword: this.$route.query.searchWord || ''
      });
      const {
        pageInfo: { totalCount }
      } = await plp?.checkCondition(sendData);
      this.$emit('changeTotalCount', totalCount);
    },

    backToTop() {
      // 回到顶部
      // const $scroll = document.querySelector('.sp-wrapper-scroll');
      // const adContainer = document.querySelector('.ad-page-top');
      // const adHeight = adContainer ? adContainer.offsetHeight : 0;
      // $scroll && $scroll.scrollTo(0, adHeight);
      // setTimeout(() => {
      //   const leftContainer = document.querySelector('.page-plp_filter');
      //   const leftContainerParent = document.querySelector('.page-plp-left');
      //   if (leftContainer) {
      //     // leftContainer.style.position = 'relative';
      //     // leftContainer.style.bottom = '0px';
      //     // leftContainer.style.top = '0px';
      //     // leftContainer.style.height = 'auto';
      //     // leftContainerParent.style.display = 'block';
      //     // leftContainerParent.style.height = 'auto';
      //     leftContainerParent.classList.remove('flex');
      //     leftContainerParent.classList.remove('fixed');
      //     leftContainerParent.classList.remove('sticky');
      //     leftContainerParent.classList.add('relative');
      //     leftContainerParent.style.height = 'auto';
      //   }
      // }, 500);
      // scrollToTop();
      if (this.filterSideIsSticky) {
        // 筛选栏吸顶，滚动到筛选栏，筛选栏未吸顶，不做操作
        const $scroll = document.querySelector('html'); // 整个页面滚动至 筛选栏吸顶位置
        // 获取 top title 和 filterbar 元素
        const topTitleElement = document.querySelector('.mobile_header-layer');
        const topPlpElement = document.querySelector('.slot-page-plp-top'); // 筛选栏的title：xx拖鞋 xx件商品
        const topPlpElement2 = document.querySelector('.sp-swiper-container'); // 顶部slide图
        // 计算元素高度
        const topTitleHeight = topTitleElement?.offsetHeight || 0;
        const topPlpHeight = topPlpElement?.offsetHeight || 0;
        const topPlpHeight2 = topPlpElement2?.offsetHeight || 0;
        // 设置触发吸顶的位置
        const triggerPosition = topTitleHeight + topPlpHeight + topPlpHeight2;
        $scroll && $scroll.scrollTo(0, triggerPosition);
      }
    },
    trackData(name) {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      const { list = [], ...others } = data;
      const primary_category = list.length && list[0];
      const secondary_category = primary_category?.children?.length && primary_category.children[0];
      const third_category = secondary_category?.list?.length && secondary_category.list[0];
      this.$trackHelp.track('productScreen', {
        belong_page: '商品列表页',
        primary_category: primary_category?.categoryName,
        secondary_category: secondary_category?.name,
        third_category: third_category?.categoryName,
        list_name: name
      });
    },
    handleSelect(status) {
      this.$set(this.selectedData, this.sizeList.code, []);
      if (status && this.bindValue.length) {
        const length = this.bindValue.length;
        this.bindValue.forEach((ele, index) => {
          const obj = this.sizeList.list.find(item => {
            return item.code == ele;
          });
          if (length - 1 > index) {
            if (this.selectedData[this.sizeList.code]) {
              this.selectedData[this.sizeList.code].push(obj);
              this.$set(
                this.selectedData,
                this.sizeList.code,
                this.selectedData[this.sizeList.code]
              );
            } else {
              this.$set(this.selectedData, this.sizeList.code, [obj]);
            }
          } else {
            this.onChange(obj, this.sizeList);
          }
        });
        this.visible2 = false;
      } else if (status && this.bindValue.length === 0) {
        this.onFilter(this.selectedData[this.sizeList.code], this.sizeList);
        this.visible2 = false;
      } else if (!status) {
        this.$set(this.selectedData, this.sizeList.code, []);
        this.bindValue = [];
      }
    },
    handleSelect2(status) {
      this.$set(this.selectedData, this.sexList.code, []);
      if (status && this.bindValue2.length) {
        const length = this.bindValue2.length;
        this.bindValue2.forEach((ele, index) => {
          const obj = this.sexList.list.find(item => {
            return item.code == ele;
          });
          if (length - 1 > index) {
            if (this.selectedData[this.sexList.code]) {
              this.selectedData[this.sexList.code].push(obj);
              this.$set(this.selectedData, this.sexList.code, this.selectedData[this.sexList.code]);
            } else {
              this.$set(this.selectedData, this.sexList.code, [obj]);
            }
          } else {
            this.onChange(obj, this.sexList);
          }
        });
        this.visible3 = false;
      } else if (status && this.bindValue2.length === 0) {
        this.onFilter(this.selectedData[this.sexList.code], this.sexList);
        this.visible3 = false;
      } else if (!status) {
        this.$set(this.selectedData, this.sexList.code, []);
        this.bindValue2 = [];
      }
    },
    onSortChangeI(code) {
      this.priceStatus = 0;
      this.radioSearch = 1;

      this.visible1 = false;
      this.onSortChange(code);
    },
    onSortChange(code) {
      this.sort = code;
      const data = this.sortList.list.find(i => i.code === code);
      this.onChange(data, this.sortList);
    },
    rotatePrice() {
      if (this.priceStatus === 0) {
        this.priceStatus = 1;
        this.radioSearch = 2;

        // 低到高
        this.onSortChange('price-0');
      } else if (this.priceStatus === 1) {
        this.priceStatus = 2;
        this.radioSearch = 2;

        // 低到高
        this.onSortChange('price-1');
      } else if (this.priceStatus === 2) {
        this.priceStatus = 0;
        this.radioSearch = 1;
        this.onSortChangeI('sort');
      }
    },
    selectNewProduct() {
      this.priceStatus = 0;
      this.sort = 'sort';
      this.radioSearch = 3;
      this.onSortChange('firstOnboardTime');
    },
    onSelected(val) {
      this.$emit('onSelected', val);
    },
    clickFilterButton() {
      this.$refs['plp-drawer'].clickFilterButton(this.bindValue, this.selectedData);
      this.$refs['plp-drawer'].drawer = true;
    },
    mergeOption(sizeBindValue, sexBindValue, selectedData) {
      this.$nextTick(() => {
        this.bindValue = sizeBindValue || [];
        this.bindValue2 = sexBindValue || [];
        console.log('aaaaa', selectedData);
        this.$set(this.selectedData, 'SIZE', selectedData.SIZE || []);
        this.$set(this.selectedData, 'PDP_SEX', selectedData.PDP_SEX || []);
        // fix hint 弹框的产品状态不传递到外层的nav side
        this.unidirectionSelectedDataStatus = true;
        this.$set(this.selectedData, 'CATEGORY', selectedData.CATEGORY || []);

        // 将子组件drawer的筛选项合并到当前组件的this.selectedData中
        this.$set(selectedData, 'Sort', this.selectedData.Sort || []);
        for (const key in selectedData) {
          this.$set(this.selectedData, key, selectedData[key] || []);
        }
      });
    },
    resetVisible(typeIndex) {
      if (!(this.visible1 && typeIndex === 1)) this.visible1 = false;
      if (!(this.visible2 && typeIndex === 4)) this.visible2 = false;
      if (!(this.visible3 && typeIndex === 3)) this.visible3 = false;
    },
    resetVisible2() {
      this.visible1 = false;
      this.visible2 = false;
      this.visible3 = false;
    },
    resetParentFilterOption() {
      this.$nextTick(() => {
        this.selectedData = {};
        this.radioSearch = 1;
        this.priceStatus = 0;
        this.bindValue = [];
        this.bindValue2 = [];
        this.$set(this.selectedData, 'PDP_SEX', []);
        this.$set(this.selectedData, 'SIZE', []);
        this.resetFilterData();
      });
    },
    // FIXME:弹出动画
    activeCircle() {
      // this.showCircle = true;
      // setTimeout(() => {
      //   const circle = document.getElementById('product-filter-mobile-circle-id');
      //   circle.classList.add('rotate-animation');
      // }, 0);
    },
    // FIXME
    // setDrawerWrapperStyle() {
    //   // 选择具有特定类名的所有元素
    //   // var elements = document.getElementsByClassName('el-drawer__wrapper');
    //   const elements = document.querySelectorAll('.ttb-drawer .el-drawer__wrapper');
    //   console.log('elementsa', elements);
    //   if (elements) {

    //   if (
    //     this.categoryList.list &&
    //     this.categoryList.list.length &&
    //     this.$route.name !== 'plpSearch'
    //   ) {
    //     if (this.showTypeSide) {
    //       // 设置样式 层级小于3，展示类型筛选项
    //       for (let i = 0; i < elements.length; i++) {
    //         // elements[i].style.height = 'calc(100vh - 182px)';
    //         // elements[i].style.top = '182px';
    //         elements[i].style.height = 'calc(100vh - 102px)';
    //         elements[i].style.top = '102px';
    //       }
    //     } else {
    //       // 层级大于3，不展示类型筛选项
    //       for (let i = 0; i < elements.length; i++) {
    //         elements[i].style.height = 'calc(100vh - 50px)';
    //         elements[i].style.top = '50px';
    //       }
    //     }
    //   } else {
    //     // 设置样式 search搜索，不展示筛选项
    //     for (let i = 0; i < elements.length; i++) {
    //       // elements[i].style.height = 'calc(100vh - 130px)';
    //       // elements[i].style.top = '130px';
    //       elements[i].style.height = 'calc(100vh - 50px)';
    //       elements[i].style.top = '50px';
    //     }
    //     }
    //   }

    // },
    setDrawerWrapperStyle() {
      // 选择具有特定类名的所有元素
      const elements = document.querySelectorAll('.ttb-drawer .el-drawer__wrapper');
      console.log('elements:', elements);

      if (elements.length) {
        // 公共部分：设置高度和顶部偏移
        const [heightOffset, topOffset] = this.getOffsets();

        elements.forEach((el, index) => {
          el.style.height = `calc(100vh - ${heightOffset}px)`;
          el.style.top = `${topOffset}px`;
        });
      }
    },

    // 新增辅助函数来根据条件计算偏移量
    getOffsets() {
      if (
        this.categoryList.list &&
        this.categoryList.list.length &&
        this.$route.name !== 'plpSearch'
      ) {
        return this.showTypeSide ? [102, 102] : [50, 50];
      } else {
        return [50, 50];
      }
    },
    packedCategoryList() {
      let list = [];
      this.categoryList.list.forEach(ele => {
        list = list.concat(ele.list);
      });
      console.log(
        'packedCategoryList',
        list.map(ele => {
          return ele.categoryName || ele.name;
        })
      );
      return list;
    },
    setupClickEvent(element) {
      element.addEventListener('click', e => {
        e.stopPropagation(); // 阻止事件冒泡到父盒
        // console.log('我点击了子盒');
      });
      const elDrawerBodies = document.querySelectorAll('.el-drawer__body');
      elDrawerBodies.forEach(elDrawerBody => {
        elDrawerBody.addEventListener('click', e => {
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          // console.log('我点击了父盒');
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.plp-nav-side-mobile {
  width: 100%;
  padding: 16px 20px 16px 20px;
  display: inline-block;

  /* 隐藏滚动条轨道 */
  ::-webkit-scrollbar {
    width: 4px;
    height: 0;
  }

  /* 隐藏滚动条的 thumb（拖动滑块） */
  ::-webkit-scrollbar-thumb {
    background: black; /* 使滑块透明 */
  }
  .active {
    color: var(--main-color-ua-dark-grey, #14141e);
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    height: 20px;
    text-transform: capitalize;
    position: relative; /* 让伪元素相对于父元素定位 */
    display: inline-block; /* 使 div 仅占用所包含文本的宽度 */
  }
  .active::after {
    content: ''; /* 伪元素内容为空 */
    display: inline-block; /* 将伪元素变为块级元素，以占据一行 */
    width: 100%; /* 横杠的宽度与父元素宽度相同 */
    height: 4px; /* 横杠的高度 */
    background-color: #dc0019; /* 横杠的颜色 */
    position: absolute; /* 使伪元素相对于父元素绝对定位 */
    bottom: 0; /* 将伪元素置于底部 */
    left: 0; /* 伪元素与父元素左侧对齐 */
    top: 19px;
  }
  &__sub-item {
    display: inline-block;
    color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
    text-align: center;
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    height: 20px;
    text-transform: capitalize;
  }
  &__sub-item:not(:first-of-type) {
    margin-left: 28px;
  }
  &__sort {
    display: flex;
    // margin-top: 20px;
    .radio-search {
      //有选中项的黑色字体效果
      overflow: hidden;
      color: var(--main-color-ua-dark-grey, #14141e);
      text-overflow: ellipsis;

      /* cn/pingfang/bold/16 */
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 137.5% */
      text-transform: capitalize;
    }
  }
  &__sort-span {
    color: var(--main-color-ua-dark-grey, #14141e);
    font-family: PingFang SC;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    text-transform: capitalize;
    display: flex;
    align-items: center;
  }
  .show-text-span {
    display: inline-block;
    max-width: 54px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .middle {
    vertical-align: middle;
  }
  .dropdown-menu {
    padding: 24px;
    margin-top: 30px;
  }
  .arrow-down-transition {
    transition: all 0.5s;
  }
  .rotate {
    transform: rotate(180deg);
  }
}
</style>
<style lang="scss">
.plp-nav-side-mobile {
  .el-popover {
    padding: 24px 24px 32px 24px !important;
  }
  .el-popover__title {
    margin-bottom: 16px !important;
    color: var(--main-color-ua-dark-grey, #14141e);

    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    text-transform: capitalize;
  }
  .popover-box {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    min-height: 84px;
    max-height: 220px;
    overflow: auto;
    padding: 0px 20px 0 20px;
    background: white;
    border: 1px solid wihte;
    .popover-item {
      display: inline-block;
      border: 1px solid #dddddd;
      width: 50px;
      padding: 10px 0;
      text-align: center;
    }
  }
  .popover-bottom {
    margin-top: 0px;
    display: flex;
    background: white;
    padding: 20px 20px 32px 20px;
    &__common {
      height: 38px;
      border-radius: 1px !important;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      text-transform: capitalize;
      width: calc((100% - 48px) / 2);
    }
    &__cancel {
      border: 1px solid var(--main-color-ua-dark-grey, #14141e) !important;
      margin-left: 20px;
    }
    &__confirm {
      margin-left: 8px;
      background: var(--main-color-ua-dark-grey, #14141e) !important;
      color: var(--main-color-ua-white, #fff) !important;
    }
  }
  .dropdown-item {
    width: 100%;
    display: inline-block;
    display: flex;
    align-items: center;
    color: var(--secondary-color-ua-cool-grey-04, #50505a);

    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 46px;
    height: 46px;
    text-transform: capitalize;
    cursor: pointer;
  }
  .dropdown-item:not(:first-of-type) {
    border-top: 1px solid #eeeeee;
  }
  .select-1 {
    color: var(--secondary-color-ua-cool-grey-04, #14141e);
    font-weight: 600;
  }

  .ttb-drawer .el-drawer__wrapper {
    // height: calc(100vh - 130px);
    position: absolute !important;
    width: 100vw;
    // top: 130px !important;
  }
  .popover-box2 {
    padding: 12px 20px 32px 20px;
    background: white;
  }
  .gt-drawer .el-drawer__header {
    // height: 18px;
    color: var(--main-color-ua-dark-grey, #14141e);
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    text-transform: capitalize;
    padding: 12px 20px 8px 20px;
    background: white;
    margin-bottom: 0px;
  }
  .el-drawer {
    background: var(--darkgrey-60, rgba(20, 20, 30, 0.6));
  }
  .ml-auto {
    margin-left: auto !important;
  }
}
// .product-filter-mobile-circle-class {
//   position: absolute;
//   width: 846px;
//   height: 846px;
//   background-color: white; /* 设置圆形背景颜色 */
//   border-radius: 50%; /* 将元素设置为圆形 */
//   // animation: rotateCircle 2s linear forwards;
//   transform-origin: top right;
//   // transform: translate(-217px, -54px);
//   top: -54px;
//   left: -217px;
//   transform: rotate(180deg); /* 从右上角开始，0度旋转 */
// }
// /* 添加新的类来定义动画 */
// .rotate-animation {
//   animation: rotateCircle 2s linear forwards;
// }
// @keyframes rotateCircle {
//   from {
//     transform: rotate(180deg); /* 从右上角开始，0度旋转 */
//   }
//   to {
//     transform: rotate(0deg); /* 顺时针旋转180度 */
//   }
// }
</style>
